import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "signalR";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
export const REQUEST_TASK_RUNNING = "RequestTaskRunning";
export const SOURCE_TASK_RUNNING = "SourceTaskRunning";
export const REQUEST_TASK_COMPLETED = "RequestTaskCompleted";
export const SOURCE_TASK_COMPLETED = "SourceTaskCompleted";
export const SUMMARY_REPORT_OBJECT_ADDED = "SummaryReportObjectAdded";
export const TASK_LOG_ITEM_ADDED = "TaskLogItemAdded";
export const SOCIAL_COMMENT_TASK_COMPLETED = "SocialCommentTaskCompleted";
export const SOCIAL_LIKE_TASK_COMPLETED = "SocialLikeTaskCompleted";
export const ONTOLOGICAL_MODEL_UPDATED = "OntologicalModelUpdated";
